export const STATUS_INIT = 0;
export const STATUS_REGISTERED = 1;
export const STATUS_BLOCKED = 2;
export const STATUS_UPDATE = 3;
